package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/**
 * Every text the interface shows, grouped by the area that shows it.
 *
 * The strings come from `i18n/strings.json`, which is the single place to change them.
 * They are generated as a typed interface with one object per language so the compiler
 * still refuses an incomplete translation: reading the JSON at runtime would give the
 * single file and lose the guarantee.
 */
interface Strings {
    val chat: ChatStrings
    val artifact: ArtifactStrings
    val history: HistoryStrings
    val rail: RailStrings
    val gate: GateStrings
    val landing: LandingStrings
    val activity: ActivityStrings
    val errors: ErrorsStrings
    val brief: BriefStrings
}

/** Everything the interface says in Spanish. */
object SpanishStrings : Strings {
    override val chat: ChatStrings = SpanishChatStrings
    override val artifact: ArtifactStrings = SpanishArtifactStrings
    override val history: HistoryStrings = SpanishHistoryStrings
    override val rail: RailStrings = SpanishRailStrings
    override val gate: GateStrings = SpanishGateStrings
    override val landing: LandingStrings = SpanishLandingStrings
    override val activity: ActivityStrings = SpanishActivityStrings
    override val errors: ErrorsStrings = SpanishErrorsStrings
    override val brief: BriefStrings = SpanishBriefStrings
}

/** Everything the interface says in English. */
object EnglishStrings : Strings {
    override val chat: ChatStrings = EnglishChatStrings
    override val artifact: ArtifactStrings = EnglishArtifactStrings
    override val history: HistoryStrings = EnglishHistoryStrings
    override val rail: RailStrings = EnglishRailStrings
    override val gate: GateStrings = EnglishGateStrings
    override val landing: LandingStrings = EnglishLandingStrings
    override val activity: ActivityStrings = EnglishActivityStrings
    override val errors: ErrorsStrings = EnglishErrorsStrings
    override val brief: BriefStrings = EnglishBriefStrings
}
